import styles from '@/styles/components/Button.module.scss'
import { ButtonHTMLAttributes, FC } from 'react'
import { classNames } from '@tmap-web-lib/utils'

export type ButtonSize = 'xsmall' | 'small' | 'medium' | 'large' | 'xlarge'
export type ButtonVariant = 'primary' | 'secondary' | 'stroke' | 'ghost'
export type ButtonColor = 'default' | 'alternative' | 'danger'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  size?: ButtonSize;
  variant?: ButtonVariant;
  color?: ButtonColor;
  isBold?: boolean;
}

export const Button: FC<ButtonProps> = ({
  size = 'medium',
  variant = 'primary',
  color = 'default',
  isBold,
  children,
  className,
  disabled,
  ...props
}) => {

  return (
    <button
      type='button'
      className={classNames(
        styles.button,
        styles[size],
        styles[variant],
        styles[color],
        isBold ? styles['bold'] : undefined,
        className,
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  )
}
